<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    MarketContent(v-if="id" :id="id" :name="name")
</template>

<script>
import Container from './Container.vue';
import MarketContent from './MarketContent.vue';

export default {
    props: ['fileId'],
    data() {
        return {
            id: '',
            name: '',
        }
    },
    methods: {
        afterload(info) {
            this.id = info.id;
            this.name = info.name;
        }
    },
    components: {
        Container,
        MarketContent
    }
}
</script>
